import { render, staticRenderFns } from "./Glossaire.vue?vue&type=template&id=7f158b11&scoped=true"
import script from "./Glossaire.vue?vue&type=script&lang=js"
export * from "./Glossaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f158b11",
  null
  
)

export default component.exports